import moment from "moment";

export const getWeek = (isoDate: string) => {
    const date = moment(isoDate);
    const weekNumber = date.isoWeek();
    const label = getDateRange(isoDate)

    return {weekNumber, label}
}

function getDateRange(isoDate: string): {firstDayWeek: string, lastDayWeek: string} {
    const date = moment(isoDate);
    const monday = date.clone().startOf('isoWeek');
    const sunday = date.clone().endOf('isoWeek');
    const sameMonth = monday.month() === sunday.month();
    const sameYear = monday.year() === sunday.year();

    if (sameMonth && sameYear) {
        return {
            firstDayWeek: `${monday.date()}`, 
            lastDayWeek: `${sunday.date()} ${sunday.format('MMMM')} ${sunday.year()}`
        };
    }

    if (sameYear) {
        return {
            firstDayWeek: `${monday.format('D MMMM')}`, 
            lastDayWeek: `${sunday.format('D MMMM')} ${sunday.year()}`
        };
    }

    return {
        firstDayWeek: `${monday.format('D MMMM')} ${monday.year()}`, 
        lastDayWeek: `${sunday.format('D MMMM')} ${sunday.year()}`
    };
}

export const getShortDate = (isoDate: string) => {
    const d = moment(isoDate);
    const day = d.date().toString().padStart(2, "0");
    const month = (d.month() + 1).toString().padStart(2, "0");
    const year = d.year();

    return `${day}/${month}/${year}`;
};

export const getLongDate = (isoDate: string) => {
    const d = moment(isoDate);
    const day = d.date();
    const month = d.format("MMMM");
    const year = d.year();

    return `${day} ${month} ${year}`;
};